import React, { useState } from 'react';
import { ArrowLeftRightIcon, ClockIcon, HourglassIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { followUps, registrations, swapOffers, type Registration, type SwapOffer } from '../../data/loisirs';
import { SwapDialog } from './SwapDialog';
export function MyActivities() {
  const [swapping, setSwapping] = useState<Registration | null>(null);
  const [pending, setPending] = useState<Record<string, SwapOffer>>({});
  return <section aria-labelledby="mes-activites-titre" className="mt-14" data-id="element-2129" data-mp="x2n2w2r1mihx">
      <h2 id="mes-activites-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-2130" data-mp="11w9fxw14coe9">
        Mes activités
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-2131" data-mp="o28f8wqlwrb9">Vos inscriptions et celles de votre famille.</p>

      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)] lg:gap-8" data-id="element-2132" data-mp="t0rz8rln3t0z">
        <ul className="space-y-3" data-id="element-2133" data-mp="e88165dckbqe">
          {registrations.map(registration => {
          const offers = swapOffers.filter(offer => offer.registrationId === registration.id).length;
          const requested = pending[registration.id];
          return <li key={registration.id} className="rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo" data-id="element-2134" data-mp="3fd2khtjpbi49">
                <div className="flex items-start gap-4" data-id="element-2135" data-mp="3p9xj0cfz5iij">
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-slate-100 text-sm font-bold text-ville-navy" aria-hidden="true" data-id="element-2136" data-mp="31n8tp5omynrw">
                    {registration.initials}
                  </span>
                  <div className="min-w-0 flex-1" data-id="element-2137" data-mp="35nizah8inc68">
                    <div className="flex flex-wrap items-center gap-2" data-id="element-2138" data-mp="35ly72y9oc5bj">
                      <h3 className="font-bold text-ville-navy" data-id="element-2139" data-mp="2hwng28i4lpal">{registration.activity}</h3>
                      <span className="rounded-full bg-ville-indigo-soft px-2.5 py-0.5 text-xs font-bold text-ville-indigo" data-id="element-2140" data-mp="2dvtqzbsy64g4">
                        {registration.participant} · inscrite
                      </span>
                    </div>
                    <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-2141" data-mp="lsph3po8gfhd">
                      <span className="flex items-center gap-1.5" data-id="element-2142" data-mp="vkvczahlvh1u">
                        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-2143" data-mp="vk3muf6s2biy" />
                        {registration.schedule}
                      </span>
                      <span className="flex items-center gap-1.5" data-id="element-2144" data-mp="2vefhyf4p9yr">
                        <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-2145" data-mp="7vajvyrqn3eu" />
                        {registration.place}
                      </span>
                    </p>
                    <p className="mt-1 text-sm font-semibold text-ville-navy" data-id="element-2146" data-mp="cvovfqsjsvhm">{registration.nextSession}</p>
                  </div>
                </div>

                {requested ? <p className="mt-3 flex items-start gap-2 rounded-xl bg-ville-sand px-4 py-3 text-[13px] text-slate-600" data-id="element-2147" data-mp="1o7zdb25r777a">
                    <HourglassIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" data-id="element-2148" data-mp="38tnwvxgcqwds" />
                    Échange proposé vers {requested.day} {requested.time} — en attente de l’autre famille. Votre
                    créneau actuel reste valide.
                  </p> : <div className="mt-3 flex flex-wrap items-center gap-3" data-id="element-2149" data-mp="2p3m00dnrag8x">
                    <button type="button" onClick={() => setSwapping(registration)} className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2150" data-mp="2p4x4kfp0zs13">
                      <ArrowLeftRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2151" data-mp="9czfor5epi9y" />
                      Échanger un créneau
                    </button>
                    <p className="text-[13px] text-slate-500" data-id="element-2152" data-mp="376jbnhxg09g7">
                      {offers} créneaux offerts par d’autres familles
                    </p>
                  </div>}
              </li>;
        })}
        </ul>

        <aside aria-label="Suivis d’ATNA" className="rounded-2xl border border-slate-200 bg-slate-50 p-5" data-id="element-2153" data-mp="2y3i6bjgeimdl">
          <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-2154" data-mp="2jec7hwlh6y68">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-2155" data-mp="2o8ggeleaxg9y" />
            Suivis d’ATNA
          </p>
          <ul className="mt-3 space-y-3" data-id="element-2156" data-mp="2ahlexu64u1ge">
            {followUps.map(item => <li key={item} className="rounded-xl bg-white px-4 py-3 text-sm leading-relaxed text-slate-600" data-id="element-2157" data-mp="2ffd62lyydjjj">
                {item}
              </li>)}
          </ul>
        </aside>
      </div>

      <SwapDialog registration={swapping} onClose={() => setSwapping(null)} onSwapped={(registrationId, offer) => setPending(current => ({
      ...current,
      [registrationId]: offer
    }))} data-id="element-2158" data-mp="25fw34cb35jr9" />
    </section>;
}